import adminRoutes from "./Admin";

/**
 * Combine and export the routes defined in the admin and user modules for better organization and easier usage.
 * @constant {Object} moduleRoutesMap
 */
const moduleRoutesMap = {
  admin: { ...adminRoutes }
};
export default moduleRoutesMap;
